module.exports = __webpack_public_path__ + "static/media/Impact.1c86c4b5.png";